import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';
import _ from 'lodash';
import { RootState } from '../../../../../@types/RootState';
import { rulePaginationLengthMenu } from '../../../../../pages/IPA/Estrategia/pages/RulesPage/lib/utils';
import { RESET_RULES_PAGE_FILTERS_CACHE, SET_RULES_PAGE_FILTERS_CACHE_BY_KEY } from '../filters/cache';
import { SET_RULES_FILTERS_NAME } from '../filters/name';
import { RESET_RULES_PAGE_FILTERS_QUERY, SET_RULES_PAGE_FILTERS_QUERY_BY_KEY } from '../filters/query';
import { SET_RULES_FILTERS_TYPE } from '../filters/type';
import { RESET_RULES_PAGE_FILTERS_VALUE } from '../filters/value';

export type RulesPagePaginationState = Record<'page' | 'size', number>;

const initialState: RulesPagePaginationState = {
  page: 1,
  size: rulePaginationLengthMenu[0].value,
};

const slice = createSlice({
  name: 'ipa.strategy.rules.table.pagination',
  initialState,
  reducers: {
    RESET_RULES_TABLE_PAGINATION: () => initialState,
    UPDATE_RULES_TABLE_PAGINATION: (state, action: PayloadAction<Partial<RulesPagePaginationState>>) => {
      return _.merge({}, state, action.payload);
    },
  },
  extraReducers: builder => {
    builder
      .addCase(SET_RULES_PAGE_FILTERS_CACHE_BY_KEY, state => {
        state.page = 1;
      })
      .addCase(RESET_RULES_PAGE_FILTERS_CACHE, state => {
        state.page = 1;
      })
      .addCase(SET_RULES_FILTERS_NAME, state => {
        state.page = 1;
      })
      .addCase(RESET_RULES_PAGE_FILTERS_QUERY, state => {
        state.page = 1;
      })
      .addCase(SET_RULES_PAGE_FILTERS_QUERY_BY_KEY, state => {
        state.page = 1;
      })
      .addCase(SET_RULES_FILTERS_TYPE, state => {
        state.page = 1;
      })
      .addCase(RESET_RULES_PAGE_FILTERS_VALUE, state => {
        state.page = 1;
      });
  },
});

export const selectorRulesPageTablePagination = (state: RootState) => {
  return state.ipa.strategy.rules.table.pagination;
};

export const { RESET_RULES_TABLE_PAGINATION, UPDATE_RULES_TABLE_PAGINATION } = slice.actions;

const reducer: Reducer<RulesPagePaginationState> = slice.reducer;

export default reducer;
